import { createRoute } from "@tanstack/react-router";
import { rootRoute } from "../../app/root-route.js";
import { GuestApp } from "./GuestApp.js";

export const guestRoute = createRoute({
  getParentRoute: () => rootRoute,
  path: "/g/$slug",
  validateSearch: (s: Record<string, unknown>): { t?: string } => ({
    t: typeof s.t === "string" ? s.t : undefined,
  }),
  component: () => {
    const { slug } = guestRoute.useParams();
    const { t } = guestRoute.useSearch();
    return <GuestApp slug={slug} t={t} defaultTab="capture" />;
  },
});
